import React from 'react'
import styled from 'styled-components';
import { ReactComponent as DragIcon } from '../../Assets/drag.svg';

export const BlockStyle = styled.div`
    ${props=>props.isDragging ? `box-shadow: 30px 30px 30px rgba(0, 0, 0, 0.5);
        position: absolute;
        z-index: 100;
        width: ${props.width}px;
        background-color: rgb(255,255,255,0.4);
        ` : null}
`

const PlaceholderStyle = styled.div`
    width: ${props=>props.width}px;
    height: ${props=>props.height}px;

    .content{
        background-color: rgb(0,0,0,0.3);
        height: 100%;
        width: 100%;
        padding: 8px;
    }
    .inner{
        display: flex;
        height: 100%;
        border-style: dotted;
        border-color: #ced2d9;
        border-radius: 5px;
        border-width: 2px;
    }

`


class BlockProxy extends React.Component {
    componentDidMount(){
    }
    render(){
        return <BlockStyle
            id={this.props.id}
            key={this.props.id}
            // style={this.props.style}
            ref={this.props.reference}>
                {this.props.children}
            </BlockStyle>
        }
}

export class Block {

    constructor(props){
        this.type = 'Block';
        this.view = props.view;
        this.id = props.id;
        this.canvas = props.canvas;
        this.ref = React.createRef();
        this.boundingRect = null;
        this.worldBoundingRect = null;
        this.localRenderBRect = null;
        this.worldRenderBRect = null;
        this.aiField = null;

        this.offset = {x: 0 , y: 0 }; //offset during drag and drop

        this.dirty = true; //dirty means needs update to recaculate some variables

        this.isHovered = false;
        this.isSelected = false;
        this.isSelectable = true;
        this.isEditing = false;
        this.isVisible = true;
        this.isDragging = false;
        this.isDraggable = true;

        this.dependents = [];
        this.children = [];
        this.parent = null;

        this.editingRef = null;
        this.textEditorStateRef = null;

        this.onChangeSubscribers = [];

        this.lockedSize = 'None';

        this.style = this.style.bind(this);

        this.attributes = [];

        this.isAutoResize = true;
        this.icon = new Image();
        this.icon.src = process.env.PUBLIC_URL+'/assets/icons/move.svg'; // todo check with nginx
    }

    addAttribute( props ){
        this[props.id] = props;
        this.attributes.push(props);
    }


    initDefault(){
        let geo = this.attributes['geometry'].value;
        this.boundingRect = {
            x:geo.x,
            y:geo.y,
            width:geo.width,
            height:geo.height
        };
        this.dirty = true;
    }
    setDirty(value){
        this.dirty = value;
        for(let block of this.children){
            block.setDirty( value );
        }
    }

    onAttributeChanged( attr ){
    }

    move(deltaGeometry){
        this.setDirty( true );
        if(this.isEditing){
            return;
        }

        this.boundingRect.x += deltaGeometry.x;
        this.boundingRect.y += deltaGeometry.y;
        this.boundingRect.width += deltaGeometry.width;
        this.boundingRect.height += deltaGeometry.height;
    }

    toLocalRender(rect){ // Convert World position in to Local space
        rect.x -= this.localRenderBRect.x;
        rect.y -= this.localRenderBRect.y;

        if(this.parent){
            rect = this.parent.toLocalRender(rect);
        }
        return rect;
    }
    toWorldRender(rect){ // Convert Local position in to World space
        if(this.parent){
            rect.x +=this.parent.localRenderBRect.x;
            rect.y += this.parent.localRenderBRect.y;
            rect = this.parent.toWorldRender(rect);
        }
        return rect;
    }

    posToWorld(point){ // Convert Local position in to World space
        if(this.parent){
            point.x +=this.parent.boundingRect.x;
            point.y += this.parent.boundingRect.y;
            point = this.parent.posToWorld(point);
        }
        return point;
    }
    setVisible(value){
        this.isVisible = value;
        this.view.setState({});
    }
    addChild( child ){
        child.parent = this;
        this.children.push( child );
    }
    removeChild( child ){
        let blockIndex = this.children.findIndex( block => block.id === child.id );
        this.children.splice(blockIndex, 1);
    }
    removeFromParent(){
        if(this.parent){
            this.parent.removeChild( this );
        }
        else{
            this.view.removeBlock( this );
        }
    }
    addDependent( value ){
        this.dependents.push( value );
    }

    editingHandle(ref){
        this.editingRef = ref;
    }

    textEditorStateHandle(ref){
        this.textEditorStateRef = ref;
    }
    addOnChangeSub(e){
        this.onChangeSubscribers.push( e );
    }
    removeOnChangeSub(e){
        let index = this.onChangeSubscribers.indexOf(e);
        if( index >= 0){
            this.onChangeSubscribers.splice(index, 1);
        }
    }
    rectContainPoint(rect, x, y){
        if(!rect){
            return false;
        }
        return rect.x <= x && x <= rect.x + rect.width &&
        rect.y <= y && y <= rect.y + rect.height;
    }

    getBlockById(id){
        if(this.id === id){
            return this;
        }
        for(let block of this.children){
            let b = block.getBlockById(id);
            if(b){
                return b;
            }
        }
        return null;
    }

    getBlocksByType(type){
        let out = [];
        if(this.type === type){
            out.push(this);
        }
        for(let block of this.children){
            out = out.concat(block.getBlocksByType(type));
        }
        return out;
    }

    getBlocksByTag(tag){
        let out = [];
        if(this.attributes['tags'].value.includes(tag)){
            out.push(this);
        }
        for(let block of this.children){
            out = out.concat(block.getBlocksByTag(tag));
        }
        return out;
    }


    blockAtPoint(x,y, ignoreBlock){
        for(let block of this.children){
            let b = block.blockAtPoint(x, y, ignoreBlock);
            if(b){
                return b;
            }
        }
        if(this.rectContainPoint(this.worldRenderBRect, x, y) && this.isSelectable && this.isVisible){
            if(ignoreBlock){
                if(ignoreBlock !== this){
                    return this;
                }
            }
            else{
                return this;
            }
        }
        return null;
    }

    setDragging( value ){
        this.isDragging = value;
        this.offset.x = 0;
        this.offset.y = 0;
    }

    setSelected( value ){
        this.isSelected = value;
    }

    setHovered( value ){
        this.isHovered = value;
        if(value == false){

            for (let child of this.children) {
                child.setHovered(value);
            }
        }
    }

    setEditing( value) {
        this.isEditing = value;
        if(this.editingRef){
            this.editingRef(value);
        }
    }
    setOffset(value){
        this.offset = value;
    }

    update(){
        if(this.ref.current){
            this.worldRenderBRect = this.ref.current.getBoundingClientRect();
            this.worldRenderBRect.x -= this.view.canvasRect.x;
            this.worldRenderBRect.y -= this.view.canvasRect.y;
        }

        for(let block of this.children){
            block.update();
        }
    }

    calculateHeight (styleHeight, geometry) {
        return styleHeight;
    }

    pack(){
        let data = {};
        data['id'] = this.id;
        data['type'] = this.type;
        data['style'] = this.styleText;
        data['styleMobile'] = this.styleMobileText;
        if(this.isSelectable === false){
            data['isSelectable'] = false;
        }

        if (this.aiField) {
           data['aiField'] = this.aiField;
        }
        if(this.isDraggable === false){
            data['isDraggable'] = false;
        }
        if(this.isVisible === false){
            data['isVisible'] = false;
        }
        if(this.name){
            data['name'] = this.name;
        }
        if(this.canHide !== undefined){
            data['canHide'] = this.canHide;
        }

        let children = [];
        for(let child of this.children){
            let data = child.pack();
            children.push(data);
        }

        data['children'] = children;

        for(let attr of this.attributes){
            data[ attr.id ] = attr.value;
        }

        return data;
    }

    unpack(data){
        this.children = [];
        this.styleText = data['style'];
        this.styleMobileText = data['styleMobile'];

        if(data['name']){
            this.name = data['name'];
        }

        if (data['aiField']) {
          this.aiField = data['aiField'];
        }

        if(data['canHide'] !== undefined){
            this.canHide = data['canHide'];
        }

        for(let child of data['children']){
            if(child !== null){
                let block = this.view.createBlock(child.type, child.id);
                block.unpack( child );
                this.addChild(block);
            }
        }

        let selectable = data['isSelectable'];
        if(selectable !== undefined && selectable === false){
            this.isSelectable = false;
        }
        let draggable = data['isDraggable'];
        if(draggable !== undefined && draggable === false){
            this.isDraggable = false;
        }

        let visible = data['isVisible'];
        if(visible !== undefined && visible === false){
            this.isVisible = false;
        }

        for(let attr of this.attributes){
            let val = data[attr.id];
            if(val !== undefined){
                this[attr.id].value = val;
            }
        }
    }
    unpackConnections(data){
    }

    style(getOriginal){
        let output;
        if(this.view.isMobileLayout() && this.styleMobileText !== undefined){
            output = this.styleMobileText;
        }else{
            output = this.styleText;
        }
        // if(this.isDragging && !getOriginal){
        //     output = output.replace(/\s/g, ''); //remove all white spaces;
        //     output = output.replace('width:100%;', ''); // remove full width if element is dragging
        // }

        return output;
    }
    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    getPlaceholder(){
        let placeholder = null;
        if(this.worldRenderBRect && this.isDragging){
            placeholder = <PlaceholderStyle
                    id={'Placeholder-'+this.id}
                    width={this.worldRenderBRect.width}
                    height={this.worldRenderBRect.height}
                    // height={50}
                    style={this.styleDict()}>
                    <div className='content'>
                        <div className='inner'>
                                <DragIcon style={{margin: 'auto',padding: '7px', width: '100%', height: '100%', maxWidth: '60px', maxHeight: '60px', objectFit: 'contain'}}/>
                        </div>
                    </div>
                </PlaceholderStyle>
        }
        return placeholder;
    }
    styleDict(){ //convert CSS style text in to JS dictinary
        let outDict = {};
        let styleText = this.style( true ); // getting original CSS styling
        let components = styleText.split(';');
        for(let element of components){
            let parts = element.split(':');
            let keyParts = parts[0].split('-');

            if(keyParts === undefined){
                outDict[parts[0]] = parts[1];
            }
            else{
                if(keyParts[0] === "" || parts.length <= 1){
                    continue;
                }

                let key = '';
                let index = 0;
                for(let keyPart of keyParts ){
                    if(index === 0){
                        key += keyPart.replace(/\s/g, '');
                    }
                    else{
                        key += this.capitalizeFirstLetter( keyPart );
                    }
                    index +=1;
                }
                outDict[key] = parts[1].replace(/\s/g, '');
            }

        }
        return outDict;
    }

    renderView(){
        return <BlockProxy
            id={this.id}
            key={this.id}
            reference={this.ref}
            styleText={this.style()}
            >
                {
                    this.children.map((child)=>{
                    return child.renderView();
                    })
                }
            </BlockProxy>
    }

    renderOverlay(ctx){
        if(this.isDragging){
            let placeholderSize = 100;
            let rect = {
                x: this.offset.x - placeholderSize * 5,
                y: this.offset.y - placeholderSize * 0.5,
                width: placeholderSize,
                height: placeholderSize
            }
            ctx.fillStyle = 'rgba(123, 134, 149, 0.6)';
            ctx.shadowColor = '#6C68FF';
            ctx.shadowBlur = 15;
            ctx.fillRect(
                rect.x,
                rect.y,
                rect.width,
                rect.height);

            let off = (placeholderSize - 26) / 2.0;
            ctx.drawImage(this.icon, rect.x + off, rect.y + off, 26, 26);
        }
        else if(this.isSelected || this.isHovered){

            let rect = this.worldRenderBRect;
            //make it 1 pixel smaller since line is 2 pixels thick.
            rect = {
                x: rect.x + 1,
                y: rect.y + 1,
                width: rect.width - 2,
                height: rect.height - 2
            }
            ctx.strokeStyle = this.isSelected ? '#6C68FF' : '#9f9f9f';
            ctx.lineWidth = this.isSelected ? 2 : 1;
            ctx.strokeRect(
                rect.x,
                rect.y,
                rect.width,
                rect.height);

        }

        for (let child of this.children) {
            child.renderOverlay(ctx);
        }
    }
}
